import { useSuspenseQuery } from '@apollo/client';

import type {
  SeoJobRoleLocations,
  SeoJobRoleSkills,
} from '@xing-com/crate-common-graphql-types';
import { SeoJobRoleSkillsAndLocationsDocument } from '@xing-com/crate-jobs-domain-serps-graphql';

import { useSerpsMatch } from './use-serps-match';

type UseSeoLinkBoxes = {
  data: {
    skills: SeoJobRoleSkills[];
    locations: SeoJobRoleLocations[];
  };
  error?: Error | undefined;
};

export const useSeoJobRoleSkillsAndLocations = (): UseSeoLinkBoxes => {
  const serpMatch = useSerpsMatch();
  const { data, error } = useSuspenseQuery(
    SeoJobRoleSkillsAndLocationsDocument,
    {
      variables: {
        jobRole: serpMatch?.categoryValue || '',
        serpType: 'jobRole',
      },
      errorPolicy: 'all',
    }
  );

  return {
    data: {
      skills:
        data?.seoJobRoleSkills?.collection.filter(
          (skill): skill is SeoJobRoleSkills => skill !== null
        ) || [],
      locations:
        data?.seoJobRoleLocations?.collection.filter(
          (location): location is SeoJobRoleLocations => location !== null
        ) || [],
    },
    error,
  };
};
